// extracted by mini-css-extract-plugin
module.exports = {"card":"_71c8e14","highlightDisabled":"_0011c04"};